import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { mqV } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledContentContainer = styled.div`
	${(p) => css`
		flex: 1;
		min-height: 0;
		width: 100%;
		background-color: ${p.theme.colors.transparentBlack};

		${mqV(EMediaQuery.sm, `background-color: transparent;`)}
	`}
`;

export const StyledTextContainer = styled.div`
	height: 100%;
	overflow-y: auto;
	padding-left: ${(p) => p.theme.spacing['xs']};
`;
